import { defineComponent as _defineComponent } from 'vue'
import type { StreamingChartModuleFragment } from '@/features/onboarded-home/types';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import StreamingChartList from '@/features/onboarded-home/components/modules/streaming-chart/StreamingChartList.vue';

import { calculateUrl } from '@/helpers/state-helper';
import { TitleOrder } from '@/enums/title-order';
import { CollectionType } from '@/enums/collection-type';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';

import { useConstantStore } from '@/helpers/composables/useStores';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';

import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: StreamingChartModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const router = useRouter();
const { providersByShortName } = useConstantStore();

function getPopularUrl(providerShortName: string) {
	return calculateUrl(
		router,
		undefined,
		CollectionType.POPULAR,
		{
			providers: [providerShortName],
			sort_by: TitleOrder.TRENDING,
		},
		providersByShortName.value
	);
}

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, router, providersByShortName, getPopularUrl, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, ProviderIcon, HiddenHorizontalScrollbar, StreamingChartList }
}

})